export const environment = {
    production: true,
    env: 'production',
    apiUrl: 'https://api.ramp.cdrc.app',
    s3BucketName: '',
    whitelistedDomains: ['api.ramp.cdrc.app'],
    blacklistedRoutes: [],
    imgixDomain: 'https://images.ramp.cdrc.app',
    vapidPubKey: 'BMxnj8mJKGxvYktBKR7C-NWLZBpMtC59-50gGj6AhC0RbFmF8ArKnQvGYtJEqRfUvQ_BLcSqFD5enNdoMmARJ7o',
    gaMeasurementId: 'G-4DDFWN4W7E',
};
